import { useCallback, useEffect, useState } from "react";
import { Table } from "antd";
import { dataWrapper } from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { ColumnsType } from "antd/es/table";

type BankAccounts = {
  staffNo: string;
  staffType: string;
  bankAcctNo: string | null;
  nameInBank: string | null;
  effective: string | null;
  isAppt: string
};

const bankAccColumns: ColumnsType<BankAccounts> = [
  {
    title: "Staff Number",
    dataIndex: "staffNo",
    key: "staffNo",
    width: 200,
  },
  {
    title: "Bank Account Name",
    dataIndex: "nameInBank",
    key: "nameInBank",
    width: 450,
  },
  {
    title: "Bank Account Number",
    dataIndex: "bankAcctNo",
    key: "bankAcctNo",
  },
];

const AccountPage = () => {
  const dispatch = useDispatch();
  const staffNo = useSelector((state: RootState) => state.session.staffNo);
  // console.log("*****staffNo:", staffNo);
  const [bankAccounts, setBankAccounts] = useState<BankAccounts[]>([]);

  const fetchData = useCallback(async () => {
    const response: any = await dispatch(
      dataWrapper(
        "ptps/getBankAcc",
        // @ts-ignore
        {
          data: {
            staffNo,
          },
        },
        "POST"
      )
    );
    const data = response?.value;
    setBankAccounts(data);
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  // useEffect(() => {
  //   console.log("*****bankAccounts:", bankAccounts);
  // }, [bankAccounts]);

  return (
    <div className={`container static-content`}>
          <Table
            columns={bankAccColumns}
            dataSource={bankAccounts}
            pagination={false}
          />
    </div>
  );
};

export default AccountPage;
